import React from 'react';
import { Form, Row, Col, Button } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import Input from '../../components/input/Input';
import Select from '../../components/selects/Select';
import { displayMessage } from '../../helpers/messages';
import EUserTypes from '../../enums/EUserTypes';

const UserFilters = ({ onFilter, onClear }) => {
  const [form] = Form.useForm();

  const handleFilter = (values) => {
    onFilter(values);
  };

  const handleClear = () => {
    form.resetFields();
    onClear();
  };

  const userTypeOptions = Object.values(EUserTypes).map(type => ({
    value: type.code,
    label: type.description,
  }));

  const statusOptions = [
    { value: true, label: displayMessage('ACTIVE') },
    { value: false, label: displayMessage('INACTIVE') },
  ];

  return (
    <Form
      form={form}
      onFinish={handleFilter}
      layout="vertical"
      style={{ marginBottom: 16 }}
    >
      <Row gutter={16}>
        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('FIRST_NAME')}
            name="by_name"
          >
            <Input placeholder="Buscar por nome" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('EMAIL')}
            name="by_email"
          >
            <Input placeholder="Buscar por e-mail" />
          </Form.Item>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Form.Item
            label={displayMessage('STATUS')}
            name="by_is_active"
          >
            <Select
              placeholder="Selecione o status"
              options={statusOptions}
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button
            icon={<ClearOutlined />}
            onClick={handleClear}
            style={{ marginRight: 8 }}
          >
            {displayMessage('CLEAR')}
          </Button>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            htmlType="submit"
          >
            {displayMessage('FILTER')}
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default UserFilters;



